import { render } from "./TheHeaderNavigation.vue?vue&type=template&id=26803766"
import script from "./TheHeaderNavigation.vue?vue&type=script&lang=js"
export * from "./TheHeaderNavigation.vue?vue&type=script&lang=js"
script.render = render

export default script